var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastCommunicatedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33788_5617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6504 1H10.6504L8.15039 4H5.15039C4.61996 4 4.11125 4.21071 3.73618 4.58579C3.3611 4.96086 3.15039 5.46957 3.15039 6V15C3.15039 15.5304 3.3611 16.0391 3.73618 16.4142C4.11125 16.7893 4.61996 17 5.15039 17H21.1504C21.6808 17 22.1895 16.7893 22.5646 16.4142C22.9397 16.0391 23.1504 15.5304 23.1504 15V6C23.1504 5.46957 22.9397 4.96086 22.5646 4.58579C22.1895 4.21071 21.6808 4 21.1504 4H18.1504L15.6504 1Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1504 13C14.8072 13 16.1504 11.6569 16.1504 10C16.1504 8.34315 14.8072 7 13.1504 7C11.4935 7 10.1504 8.34315 10.1504 10C10.1504 11.6569 11.4935 13 13.1504 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33788_5617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastCommunicatedOn);
export default __webpack_public_path__ + "static/media/lastCommunicatedOn.9691cd5ef15f865097797097531be591.svg";
export { ForwardRef as ReactComponent };